import type { App } from 'vue';
import { createPinia } from 'pinia';

// Create and export Pinia
export const pinia = createPinia();

export default {
	install(app: App) {
		app.use(pinia);
	}
};
